import type { adminDe } from './admin.de';

export const adminEn: typeof adminDe = {
  login: {
    title: 'Admin panel',
    subtitle: 'Sign in to manage requests and content.',
    email: 'Email',
    password: 'Password',
    submit: 'Sign in',
    submitting: 'Signing in…',
    failed: 'Email or password is incorrect.',
    backToSite: 'Back to the website',
  },
  nav: {
    dashboard: 'Overview',
    leads: 'Requests',
    projects: 'Projects',
    content: 'Content',
    settings: 'Settings',
    users: 'Users',
    logout: 'Sign out',
    viewSite: 'View website',
  },
  dashboard: {
    title: 'Overview',
    subtitle: 'All requests at a glance.',
    total: 'Total requests',
    last7: 'Last 7 days',
    last30: 'Last 30 days',
    open: 'Open',
    trend: 'Requests over the last 30 days',
    byStatus: 'By status',
    recent: 'Latest requests',
    empty: 'No requests yet.',
  },
  leads: {
    title: 'Requests',
    subtitle: '{{count}} requests',
    search: 'Search by name, email, city…',
    filterStatus: 'Status',
    filterInterest: 'Interest',
    all: 'All',
    export: 'Export CSV',
    empty: 'No requests found.',
    emptyHint: 'Adjust the filters or wait for new requests.',
    columns: {
      name: 'Name',
      contact: 'Contact',
      location: 'Location',
      availability: 'Availability',
      status: 'Status',
      created: 'Received',
      actions: '',
    },
    detail: {
      title: 'Request',
      contact: 'Contact details',
      request: 'Request',
      notes: 'Internal notes',
      addNote: 'Add note',
      notePlaceholder: 'Note about this request…',
      noNotes: 'No notes yet.',
      delete: 'Delete request',
      deleteConfirmTitle: 'Delete this request?',
      deleteConfirmBody: 'This cannot be undone. All notes will be deleted as well.',
      cancel: 'Cancel',
      confirmDelete: 'Delete permanently',
      notified: 'Notification sent',
      notNotified: 'No notification sent',
      callNow: 'Call',
      whatsappNow: 'Reply on WhatsApp',
      whatsappDraft: 'Hello {{name}}, thank you for your request at PV Yourself.',
      emailNow: 'Send email',
    },
  },
  status: {
    NEW: 'New',
    CONTACTED: 'Contacted',
    SCHEDULED: 'Scheduled',
    WON: 'Won',
    LOST: 'Lost',
  },
  content: {
    title: 'Content',
    subtitle: 'Edit the services and process steps shown on the website.',
    headings: 'Section headings',
    services: 'Services',
    steps: 'Process steps',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    published: 'Published',
    hidden: 'Hidden',
    moveUp: 'Move up',
    moveDown: 'Move down',
    fields: {
      slug: 'Slug',
      icon: 'Icon',
      titleDe: 'Title (DE)',
      titleEn: 'Title (EN)',
      bodyDe: 'Body (DE)',
      bodyEn: 'Body (EN)',
      isPublished: 'Show on the website',
    },
    save: 'Save',
    cancel: 'Cancel',
    saved: 'Changes saved.',
  },
  settings: {
    title: 'Settings',
    subtitle: 'Company details and homepage copy.',
    save: 'Save',
    saved: 'Settings saved.',
    password: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    passwordChanged: 'Password changed.',
  },
  users: {
    title: 'Users',
    subtitle: 'Manage admin panel access.',
    add: 'Add user',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    active: 'Active',
    lastLogin: 'Last sign-in',
    never: 'Never',
    create: 'Create',
    password: 'Password',
  },
  projects: {
    title: 'Projects',
    subtitle: 'Show completed installations as references on the website.',
    add: 'Add project',
    edit: 'Edit project',
    empty: 'No projects yet.',
    emptyHint: 'Add your first reference project so it appears on the website.',
    chooseFile: 'Choose file',
    uploading: 'Uploading…',
    tooLarge: 'That file is too large (max {{max}}).',
    fields: {
      slug: 'Slug',
      location: 'Location / region',
      titleDe: 'Title (DE)',
      titleEn: 'Title (EN)',
      descriptionDe: 'Description (DE)',
      descriptionEn: 'Description (EN)',
      sizeKwp: 'Size in kWp',
      completedAt: 'Completed',
      componentsDe: 'Components (DE)',
      componentsEn: 'Components (EN)',
      image: 'Photo',
      video: 'Video',
      isPublished: 'Show on the website',
    },
  },
  sections: {
    pillars: 'Price advantage',
    services: 'Services',
    process: 'Process',
    projects: 'Projects',
    trust: 'Trust',
    contact: 'Contact',
    fields: { eyebrow: 'Eyebrow', title: 'Heading', subtitle: 'Subtitle' },
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    saving: 'Saving…',
    error: 'Error',
    rowsPerPage: 'Rows per page',
  },
};
